<template>
  <div class="min-h-screen bg-white">
    <TopBar
      :role="this.role"
      :user-data="this.userData.data"
      v-if="userData && role"
    />

    <section class="banner">
      <div class="banner-bg bg-blueee-200 z-10">
        <div class="max-w-[1300px] m-auto h-full">
          <div class="grid md:grid-cols-12 gap-4 h-full">
            <div class="md:block md:col-span-4">
              <MobBreadcrumb
                :items="breadcrumbItems"
                back="/dashboard"
                class="hidden md:flex relative mt-8 text-neutral-400"
              />
            </div>

            <div
              class="col-span-12 md:col-span-8 relative text-right flex items-center flex-col justify-center"
            >
              <h1 class="md:block text-4xl font-bold mb-2 text-white">
                {{ course.title }}
              </h1>
              <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div class="flex flex-col items-center p-4">
                  <h2 class="font-semibold mb-2 text-neutral-400">Lecciones</h2>
                  <p class="text-lg text-white font-bold">
                    {{ course.lessons?.length }}
                  </p>
                </div>

                <div class="flex flex-col items-center p-4">
                  <h2 class="font-semibold mb-2 text-neutral-400">Prácticas</h2>
                  <p class="text-lg text-white font-bold">
                    {{ course.practices?.length }}
                  </p>
                </div>

                <div class="flex flex-col items-center p-4">
                  <h2 class="font-semibold mb-2 text-neutral-400">
                    Simulacros
                  </h2>
                  <p class="text-lg text-white font-bold">
                    {{ course.simulacrums?.length }}
                  </p>
                </div>

                <div class="flex flex-col items-center p-4 bg-white/15 rounded-xl border border-white/30">
                  <h2 class="font-semibold mb-2 text-white/90 text-center">Estudiantes inscritos</h2>
                  <p class="text-2xl text-white font-bold">
                    {{ formatStudentsCount(course.enrolledStudentsCount) }}
                  </p>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </section>

    <main class="max-w-[1300px] m-auto pt-0 pb-4 px-0">
      <CourseDetailLayout></CourseDetailLayout>
    </main>
  </div>
</template>

<script>
import { MobBreadcrumb } from "@/views/V2/components";
import TopBar from "@/views/V2/dashboard/components/TopBar.vue";
import CourseDetailLayout from "./components/CourseDetailLayout.vue";
import { getCourse } from "@/services/courses.service";
import { getEnrolledOlympics } from "@/services/olympics.service";

export default {
  name: "CourseDetail",
  components: {
    TopBar,
    MobBreadcrumb,
    CourseDetailLayout,
  },
  data() {
    return {
      breadcrumbItems: [{ label: "" }, { label: "Introducción" }],
      userData: [],
      role: "",
    };
  },
  async mounted() {
    try {
      let course = await getCourse(this.$route.params.id);
      this.$store.dispatch("course/setCourse", course);
      try {
        const { data: olympics } = await getEnrolledOlympics();
        const olympic = (olympics || []).find(
          (o) => Number(o.moduleId) === Number(course.id)
        );
        this.$store.dispatch("course/setOlympic", olympic || null);
      } catch {
        this.$store.dispatch("course/setOlympic", null);
      }

      this.role = window.localStorage.getItem("role");
      this.userData = JSON.parse(window.localStorage.getItem("auth"));

      this.breadcrumbItems[0].label = course.title;
    } catch (error) {
      const FORBIDDEN_STATUS_CODE = 403;
      if (error?.response?.status === FORBIDDEN_STATUS_CODE) {
        this.$router.push({
          name: "DashboardV2",
          params: {
            openModalPayment: true,
          },
        });
        return;
      }
      this.$toasted?.error("No pudimos cargar el curso en este momento.", {
        position: "top-center",
        duration: 3000,
      });
    }
  },
  computed: {
    course: function () {
      return this.$store.state.course.current;
    },
  },
  methods: {
    formatStudentsCount(n) {
      const num = Number(n);
      if (Number.isNaN(num) || num < 0) return "0";
      return Math.trunc(num).toLocaleString("es-CO");
    },
  },
};
</script>
<style scoped>
.banner {
  position: relative;
  overflow: hidden;
  padding-top: 30px;
  padding-bottom: 30px;
  height: 300px;
}

.banner-bg {
  background-image: linear-gradient(to bottom right, #598dff, #0078ff);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.banner-bg:after,
.banner-bg:before {
  width: 400px;
  height: 400px;
  content: "";
  position: absolute;
  left: -200px;
  top: -20%;
  transform: rotate(24deg);
  background-image: linear-gradient(
    133.6deg,
    hsla(0, 0%, 100%, 0.21) 54.65%,
    hsla(0, 0%, 100%, 0.04) 91.5%
  );
  opacity: 0.3;
  border-radius: 80px;
  z-index: -1;
}

.banner-bg:before {
  width: 554px;
  height: 564px;
  transform: rotate(-15deg);
  top: -10%;
  left: -410px;
  opacity: 0.7;
}

.banner-bg:after {
  width: 554px;
  height: 564px;
  top: auto;
  bottom: 0;
  right: -470px;
  transform: rotate(-195deg);
  opacity: 0.6;
}

@media (min-width: 768px) {
  .banner-bg:before {
    left: -255px;
    top: -20%;
  }

  .banner-bg:after {
    bottom: 0;
    right: -355px;
    left: auto;
  }
}

@media (min-width: 1024px) {
  .banner-bg:before {
    top: -30%;
    left: -155px;
  }

  .banner-bg:after {
    top: 0%;
    right: -215px;
    bottom: auto;
  }
}

@media (min-width: 1300px) {
  .banner-bg:before {
    width: 1070px;
    height: 660px;
    top: -103%;
    left: -863px;
  }

  .banner-bg:after {
    width: 1224px;
    height: 1248px;
    right: -907px;
  }
}

.grid-cols {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
</style>
